import { render } from "./IconFavoriteCircle.vue?vue&type=template&id=4eaef27a"
import script from "./IconFavoriteCircle.vue?vue&type=script&lang=js"
export * from "./IconFavoriteCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__